const ContactPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
        Contact
      </h1>

      <div className="max-w-5xl mx-auto bg-white rounded-lg shadow-md p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

          {/* INFORMAȚII */}
          <div>
            <h2 className="text-xl font-bold text-gray-800 mb-4">
              Informații de Contact - Cabinet Stomatologic Oradea | Artisan Stoma
            </h2>

              <p className="text-gray-700">
  📞 <strong>Telefon:</strong><br />
  +40 259 268 304
</p>

<a
  href="tel:+40259268304"
  className="inline-block mt-2 bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition"
>
  📞 Sună acum
</a>

            <div className="space-y-4">
              <p className="text-gray-700">
                📍 <strong>Adresă:</strong><br />
                Str. Iza nr. 15, Oradea
              </p>

              {/* BUTON NAVIGAȚIE */}
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=ARTISAN+STOMA"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-4 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition"
              >
                📍 Deschide în Google Maps
              </a>


              <p className="text-gray-700">
                ✉️ <strong>Email:</strong><br />
                artisanstoma@gmail.com
              </p>

              <p className="text-gray-700">
                ⏰ <strong>Program:</strong><br />
                Luni – Vineri: 08:00 – 18:00
              </p>


              {/* INDICAȚII EXTRA */}
              <ul className="mt-6 text-gray-600 space-y-2">
                <li>🚗 Parcare disponibilă în zonă - Magazinul Supeco</li>
                <li>🚌 Acces facil cu transportul public - 5 minute de mers pe jos de la statia de tramvai</li>
                <li>🏢 Cabinetul se află la parter</li>
              </ul>
            </div>
          </div>

          {/* HARTĂ */}
          <div className="w-full h-[350px] rounded-lg overflow-hidden shadow">
            <iframe
              title="Locație Artisan Stoma"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d679.3298309686463!2d21.917895628566516!3d47.07320131156661!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x474647c60abe6247%3A0xe9982aa082ef7cdd!2sARTISAN%20STOMA!5e0!3m2!1sro!2sro!4v1767661769167!5m2!1sro!2sro"
              className="w-full h-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

        </div>
      </div>
    </div>
  );
};

export default ContactPage;
